import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation SpaceRecordRemoveOrganizationAssignment(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $assignmentId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                spaceRecordRemoveOrganizationAssignment(
                  assignmentId: $assignmentId
                )
              }
            }
          }
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.SpaceRecordRemoveOrganizationAssignmentMutation,
  undefined,
  graphql.schema.SpaceRecordRemoveOrganizationAssignmentMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
